export const endpoint = {
  extraInfoMultiSelect: (id: number) => `user/extraInfo/${id}/options`
};
